import '../../../js/sentry';

// Base scripts
import Alpine from 'alpinejs';
import initCookieBar from '../../../js/alpine-directives/cookie-bar';
import initCarousels from '../../../js/carousel';

// Theme scripts
import initMobileNavigation from './mobile-navigation';
import initNavPopup from '../../../js/alpine-directives/nav-popup';

window.addEventListener('DOMContentLoaded', () => {
    initCarousels();
    initMobileNavigation();

    // If we're using Livewire in this project, we don't need to initialize Alpine.js here.
    // Livewire will do this automatically. To make sure Alpine.js works everywhere, we can include the scripts in the
    // layout file. Docs: https://livewire.laravel.com/docs/installation#manually-including-livewires-frontend-assets
    Alpine.data('initCookieBar', initCookieBar);
    Alpine.data('initNavPopup', initNavPopup);
    Alpine.start();
});

// Tell Vite to build all files in this directory
import.meta.glob(['../img/**']);
